import React, { useEffect, useMemo } from 'react';
import { Outlet, useMatch } from 'react-router-dom';

import { useAuth } from 'hooks/useAuth';
import { useNavigateWithParams } from 'hooks/useNavigateWithParams';

import { NavMenu } from 'components/ui/NavMenu';

import { Home } from 'components/svg/Home';
import { Star } from 'components/svg/Star';
import { Lightning } from 'components/svg/Lightning';
import { Idea } from 'components/svg/Idea';

import Dots from 'assets/pursuit-dots.png';

import { MainViewWrapper } from 'styles/shared';

export const Coach = () => {
    const { userProfile } = useAuth();
    const navigateWithParams = useNavigateWithParams();

    const coachWithNoSubRoute = useMatch('/coach');
    const submitRecapsRoute = useMatch('/coach/submit-recaps/*');
    const pastRecapsRoute = useMatch('/coach/past-recaps/*');
    const groupsRoute = useMatch('/coach/groups/*');
    const resourcesRoute = useMatch('/coach/resources/*');
    const directoryRoute = useMatch('/coach/directory/*');

    useEffect(() => {
        if (coachWithNoSubRoute != null) {
            navigateWithParams('/coach/submit-recaps');
        }
    }, [coachWithNoSubRoute, navigateWithParams]);

    const menuItems = useMemo(() => {
        const tabsToReturn = [
            {
                text: `Submit Recaps`,
                link: '/coach/submit-recaps',
                SVGComponent: Home,
                isSelected: submitRecapsRoute != null,
            },
            {
                text: `Past Recaps`,
                link: '/coach/past-recaps',
                SVGComponent: Star,
                isSelected: pastRecapsRoute != null,
            },
            {
                text: `Groups`,
                link: '/coach/groups',
                SVGComponent: Lightning,
                isSelected: groupsRoute != null,
            },
            {
                text: `Resources`,
                link: '/coach/resources',
                SVGComponent: Idea,
                isSelected: resourcesRoute != null,
            },
        ];

        if (userProfile?.type === 'Pursuit Coach') {
            tabsToReturn.push({
                text: 'Directory',
                link: '/coach/directory',
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                imageUrl: Dots,
                isSelected: directoryRoute != null,
            });
        }

        return tabsToReturn;
    }, [
        submitRecapsRoute,
        pastRecapsRoute,
        groupsRoute,
        resourcesRoute,
        userProfile?.type,
        directoryRoute,
    ]);

    return (
        <MainViewWrapper>
            <NavMenu menuItems={menuItems} />
            <Outlet />
        </MainViewWrapper>
    );
};
